import React, { useEffect, useState } from 'react';
import { Col, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { MoneyInput } from './MoneyInput';
import { SimpleSlider } from './SimpleSlider';
import { MoneyFormat } from './TextFormat';

interface InputSliderComboProps {
  min?: number;
  max?: number;
  value?: number;
  onChange?: Function;
}

const defaultChoice = (min, max) => Math.round((75 * (max - min)) / 100 + min);

export const InputSliderCombo = ({
  min = 5000,
  max = 50000,
  value = defaultChoice(min, max),
  onChange = () => {}
}: InputSliderComboProps) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    onChange(localValue);
  }, [localValue]);

  return (
    <Row>
      <Col className="mt-3 mt-sm-0">
        <MoneyInput
          min={min}
          max={max}
          value={localValue}
          onChange={v => {
            setLocalValue(v);
          }}
        />
      </Col>
      <Col sm={6}>
        <SimpleSlider
          min={min}
          max={max}
          value={localValue}
          onChange={v => {
            setLocalValue(v);
          }}
        />
        <Stack direction="horizontal" className="fs-5" style={{ height: '16px' }}>
          <Stack direction="horizontal" gap={1}>
            <FormattedMessage id="calculator.term.min" />:
            <MoneyFormat value={min} variant="text" cents={false} />
          </Stack>
          <Stack className="ms-auto" direction="horizontal" gap={1}>
            <FormattedMessage id="calculator.term.max" />:
            <MoneyFormat value={max} variant="text" cents={false} />
          </Stack>
        </Stack>
      </Col>
    </Row>
  );
};
